import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8a3306c0")
const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = {
  key: 0,
  class: "flex texts"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "APR", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 text-right" }, "Earn swap fees and boost your APR", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "apr value" }
const _hoisted_10 = {
  key: 0,
  class: "h-4 w-12"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "title"
}
const _hoisted_13 = { class: "flex-1 text-right" }
const _hoisted_14 = { class: "earn-button" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Earn ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_TokenPills = _resolveComponent("TokenPills")!
  const _component_TokenWeightPill = _resolveComponent("TokenWeightPill")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: '/pool/' + _ctx.pool.id,
      class: "header flex"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BalAssetSet, {
          size: 44,
          addresses: _ctx.iconAddresses(_ctx.pool),
          width: 100,
          maxOffset: 35
        }, null, 8, ["addresses"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_TokenPills, {
            class: "token-pill",
            tokens: _ctx.orderedPoolTokens(_ctx.pool.poolType, _ctx.pool.address, _ctx.pool.tokens),
            isStablePool: false,
            selectedTokens: [],
            showWeight: false
          }, null, 8, ["tokens"]),
          _createVNode(_component_TokenWeightPill, {
            class: "mt-[8px] inline-block w-min",
            tokens: 
                _ctx.orderedPoolTokens(_ctx.pool.poolType, _ctx.pool.address, _ctx.pool.tokens)
              
          }, null, 8, ["tokens"])
        ])
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.noApr)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString('0' + '%')))
            : (
                      !_ctx.aprs ||
                      !_ctx.aprs[_ctx.pool.address] ||
                      !_ctx.aprs[_ctx.pool.address]['yearlyAPR']
                      )
              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, { key: 1 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.aprs[_ctx.pool.address]['yearlyAPR'] + '%'), 1))
        ]),
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, "APR"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_router_link, {
            to: '/pool/' + _ctx.pool.id,
            class: "mt-[12px] block items-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_ArrowRightIcon, { class: "inline mx-1" })
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}